/**
 * Implementation of the entity model that stores entities in the memory.
 */
export class InMemoryEntityModel {
    /** @internal */
    id;
    /** @internal */
    alias;
    /** @internal */
    entities = {};
    /** @internal */
    listeners = [];
    type = [];
    constructor(id, alias) {
        this.id = id ?? createId();
        this.alias = alias;
    }
    getId() {
        return this.id;
    }
    getAlias() {
        return this.alias ?? null;
    }
    setAlias(alias) {
        this.alias = alias ?? undefined;
    }
    getEntities() {
        return { ...this.entities };
    }
    subscribeToChanges(callback) {
        this.listeners.push(callback);
        return () => {
            this.listeners = this.listeners.filter((l) => l !== callback);
        };
    }
    /**
     * Helper function to change the entities and properly notify all listeners.
     * @param updated
     * @param removed
     */
    change(updated, removed) {
        // Filter removed entities from updated
        removed = removed.filter((iri) => updated[iri] === undefined);
        this.entities = { ...this.entities, ...updated };
        for (const removedId of removed) {
            delete this.entities[removedId];
        }
        for (const listener of this.listeners) {
            listener(updated, removed);
        }
    }
}
const createId = () => (Math.random() + 1).toString(36).substring(7);
//# sourceMappingURL=in-memory-entity-model.js.map